/* Add to wishlist function */
function addToWishlist(wishlistBtn) {
    var btn = wishlistBtn ? wishlistBtn : document.querySelector('.item-wishlist');
    var productId = btn.getAttribute('data-product-id');
    var colorId = btn.getAttribute('data-product-color');
    var sizeId = btn.getAttribute('data-product-size');

    btn.setAttribute('is-processing', '');

    let datas = new URLSearchParams({
        product_id: productId,
        color_id: colorId,
        size_id: sizeId,
        need_color_id: 'true',
        need_size_id: 'true'
    });

    if (!btn.hasAttribute('in-wishlist')) {
        fetch(path_relative_root + "ajax_add_to_wishlist.php", {
            method: 'POST',
            body: datas
        })
        .then(response => response.json())
        .then(async resp => {
            if (resp.error) {
                // Leave this loop for debugging purposes

            } else {
                // DataLayer
                if (resp.result.dlv3_wishlist_item && !btn.hasAttribute('data-wishlist-tracked')) {
                    var dl_v3_obj = resp.result.dlv3_wishlist_item;
                    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && Object.keys(dl_v3_obj).length > 0) {
                        // Set the attribute so a second rapid response can't trigger this again
                        btn.setAttribute('data-wishlist-tracked', 'true');
                        DataLayerTrigger.addToWishList(dl_v3_obj['items'], dl_v3_obj['actionField']);
                    }
                }

                if (typeof wishlist !== 'undefined') {
                    wishlist = [];
                    wishlist.push(resp.result.wishlist_row_array);
                }

                // Wait for update header wishlist
                await updateHeaderWishlist();

                changeBtnAddWishlist(true, productId);
                btn.removeAttribute('is-processing');

                checkWishProductStock();

                setTimeout(function () {
                    displayWishlistTop();
                }, 0);
            }
        });
    } else {
        datas.append('remove', 'true');

        fetch(path_relative_root + 'ajax_remove_from_wishlist.php', {
            method: 'POST',
            body: datas
        })
        .then(response => response.json())
        .then(async resp => {
            if (!resp.error) {
                const ajaxUpdate = await fetch(path_relative_root + 'ajax_show_wishlist.php');
                const userWishlist = await ajaxUpdate.text();

                const wishlistTop = document.querySelector(".top-wishlist");
                if (wishlistTop) {
                    wishlistTop.innerHTML = userWishlist;
                }
                changeBtnAddWishlist(false, productId);
                btn.removeAttribute('is-processing');
                checkWishProductStock();
            }
        });
    }
}

async function updateHeaderWishlist() {
    // FONCTION UPDATE HEADER WISHLIST (+ same panier)
    const ajaxUpdate = await fetch(path_relative_root + 'ajax_show_wishlist.php');
    const userWishlist = await ajaxUpdate.text();

    const wishlistTop = document.querySelector(".top-wishlist");
    if (wishlistTop) {
        wishlistTop.innerHTML = userWishlist;
    }

    const headerUpdatedEvent = new CustomEvent('headerWishlistUpdated');
    document.dispatchEvent(headerUpdatedEvent, { detail: { wishlist: userWishlist } });
}

// Listen for wishlist update to refresh cart recap if needed
document.addEventListener('headerWishlistUpdated', function (e) {
    if (document.querySelector('.cart-wrapper')) {
        const cartNbProducts = document.querySelectorAll('.cart-wrapper .cart-product-item').length;

        toggleCartRecap(cartNbProducts);
    } else {
        return;
    }

});

// Change BTN wishlist (heart) when added/removed from wishlist
function changeBtnAddWishlist(isInWishlist, productId) {
    var btn = document.querySelector('.item-wishlist[data-product-id="' + productId + '"]');
    if (btn) {
        if (isInWishlist) {
            btn.setAttribute("in-wishlist", "");
        } else {
            btn.removeAttribute("in-wishlist");
        }
    }
}

/**
 * Vérifie si un produit est dans la wishlist (version JS native, asynchrone).
 * @param {string|number} productId - l'id du produit
 * @param {string|number} [itm_rr_id] - l'id du regroupement
 * @returns {Promise<boolean>}
 */
async function checkProductInWishlist(productId) {
    // Couleur
    let colorId = 0;
    const colorChecked = document.querySelector(`form[data-product-id="${productId}"] [name="prod_color"]:checked`);
    if (colorChecked) {
        colorId = colorChecked.value;
    } else {
        // If from cart
        if (document.querySelector('a[data-productid="' + productId + '"]')) {
            colorId = document.querySelector('a[data-productid="' + productId + '"]').getAttribute('data-colorid');
        }
    }

    // Taille
    let sizeId = 0;
    const sizeChecked = document.querySelector(`form[data-product-id="${productId}"] [name="prod_size"]:checked`);
    if (sizeChecked) {
        sizeId = sizeChecked.value;
    } else {
        // If from cart
        if (document.querySelector('a[data-productid="' + productId + '"]')) {
            sizeId = document.querySelector('a[data-productid="' + productId + '"]').getAttribute('data-sizeid');
        }
    }

    // keep fallback if we don't have color or size
    if (typeof productId === 'undefined' || typeof colorId === 'undefined' || typeof sizeId === 'undefined') {
        changeBtnAddWishlist(false, productId);
        return false;
    }

    try {
        const params = new URLSearchParams({
            product_id: productId,
            size_id: String(sizeId),
            color_id: String(colorId),
        });

        const res = await fetch(`${path_relative_root}get_user_wishlist.php?${params.toString()}`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            cache: 'no-store',
        });

        // Certaines implémentations renvoient du JSON en text/plain : on gère les deux cas
        let userWishlist;
        try {
            userWishlist = await res.json();
        } catch {
            userWishlist = JSON.parse(await res.text());
        }

        const inWishlist = Array.isArray(userWishlist) && userWishlist.length > 0;
        changeBtnAddWishlist(inWishlist, productId);
        return inWishlist;

    } catch (err) {
        // En cas d'erreur réseau / parsing, on reste prudent
        changeBtnAddWishlist(false, productId);
        return false;
    }
}

/**
 * Move wishlist header rollover product to basket
 */
function topWishToBasket(array_wishlist_product_ids) {

    document.querySelector('.rollover-basket-product[data-product-id="' + array_wishlist_product_ids[0] + '"]').setAttribute('is-processing', '');

    const divElement = Array.from(document.querySelectorAll('.rollover-wishlist-move-product')).find(function(el) {
        return el.getAttribute('data-produit-id') == array_wishlist_product_ids[0];
    });

    if (divElement) {
        const formData = new URLSearchParams({
            data: divElement.getAttribute('data-id'),
            productId: divElement.getAttribute('data-produit-id'),
            colorId: divElement.getAttribute('data-color-id'),
            sizeId: divElement.getAttribute('data-size-id')
        });

        fetch(path_relative_root + create_link('ajax_add_panier_wishlist'), {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(resp => {
            if (resp == "ok") {
                   let ProductId = formData.get('productId')
                        if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && ProductId !== undefined && typeof dl_v3_wishlist_impressions !== 'undefined' && dl_v3_wishlist_impressions !== undefined) {
                            DataLayerTrigger.wishlist_cart_product_action(dl_v3_wishlist_impressions, dlv3_action_wishlist_fields, ProductId, "add_to_cart");
                        }
                document.location.href = path_relative_root + create_link('order_basket');
            }
        });
    } else {
        const formData = new URLSearchParams({
            data: array_wishlist_product_ids.join(",")
        });
        fetch(path_relative_root + create_link('ajax_add_panier_wishlist'), {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(resp => {
            if (resp == "ok") {
                let ProductId = formData.get('productId');
                if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && ProductId !== undefined && typeof dl_v3_wishlist_impressions !== 'undefined' && dl_v3_wishlist_impressions !== undefined) {
                     DataLayerTrigger.wishlist_cart_product_action(dl_v3_wishlist_impressions, dlv3_action_wishlist_fields, ProductId, "add_to_cart");
                }
            }
        });
    }
}

function allFromWishlistToCart(array_wishlist_product_ids, isAnonymous = false) {

    if (isAnonymous) {
        const formData = new URLSearchParams({
            selectedProducts: array_wishlist_product_ids
        });

        fetch(path_relative_root + create_link('ajax_add_panier_wishlist'), {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(resp => {
            if (resp == "ok") {
                document.location.href = path_relative_root + create_link('order_basket');
            }
        });
    } else {
        const formData = new URLSearchParams({
            data: array_wishlist_product_ids.join(",")
        });

        fetch(path_relative_root + create_link('ajax_add_panier_wishlist'), {
            method: 'POST',
            body: formData
        })
        .then(response => response.text())
        .then(resp => {
            if (resp == "ok") {
                document.location.href = path_relative_root + create_link('order_basket');
            }
        });
    }
}

function moveProductFromWishlistToCart(elemBtn = false, selectedProducts = {}) {
    let datas = {};

    if (elemBtn) {
        elemBtn.parentElement.setAttribute('is-processing', '');
        var prodId = elemBtn.getAttribute("data-product-id");
        var colorId = elemBtn.getAttribute("data-color-id");
        var sizeId = elemBtn.getAttribute("data-size-id");

        datas = {
            data: elemBtn.getAttribute("data-id"),
        };

        if (prodId !== undefined) {
            datas.productId = prodId;
        }

        if (colorId !== undefined) {
            datas.colorId = colorId;
        }

        if (sizeId !== undefined) {
            datas.sizeId = sizeId;
        }
    } else {
        datas = selectedProducts;
    }

    // Convert datas to FormData for POST
    const formData = new FormData();
    for (const key in datas) {
        if (datas.hasOwnProperty(key)) {
            formData.append(key, datas[key]);
        }
    }

    fetch(path_relative_root + create_link("ajax_add_panier_wishlist"), {
        method: 'POST',
        body: formData
    })
    .then(response => response.text())
    .then(resp => {
        if (resp === "ok") {
            if (
                datas.productId !== undefined &&
                typeof dataLayer_v3 !== 'undefined' &&
                typeof dl_v3_wishlist_impressions !== 'undefined'
            ) {
                DataLayerTrigger.wishlist_cart_product_action(
                    dl_v3_wishlist_impressions,
                    dlv3_action_wishlist_fields,
                    datas.productId,
                    "add_to_cart"
                );
            }
            window.location.href = path_relative_root + create_link('order_basket');
        }
    });
}

document.addEventListener('click', function (event) {
    if (event.target.matches('.wishlist-receive-alert')) {
        document.querySelector('#bloc_add_alert_' + event.target.getAttribute('data-prod-id')).removeAttribute('is-hidden');
    }
});

/*
 * Remove product from client wishlist account page
 */
document.querySelectorAll('.wishlist-item-remove').forEach(function(button) {
    button.addEventListener('click', function() {
        button.parentElement.setAttribute('is-processing', '');
        const productId = button.getAttribute('data-product-id');
        const colorId = button.getAttribute('data-color-id');
        const sizeId = button.getAttribute('data-size-id');
        let datas = new URLSearchParams({
            product_id: productId,
            color_id: colorId,
            size_id: sizeId,
            need_color_id: 'true',
            need_size_id: 'true'
        });
        datas.append('id', productId);
        datas.append('remove', 'true');

        fetch(path_relative_root + 'ajax_remove_from_wishlist.php', {
            method: 'POST',
            body: datas
        })
        .then(response => response.json())
        .then(async resp => {
            if (!resp.error) {
                button.parentElement.remove();
                const ajaxUpdate = await fetch(path_relative_root + 'ajax_show_wishlist.php');
                const userWishlist = await ajaxUpdate.text();

                const wishlistTop = document.querySelector(".top-wishlist");
                if (wishlistTop) {
                    wishlistTop.innerHTML = userWishlist;
                }

                const cartWishlist = document.querySelector('.cart-wishlist-title');
                if (cartWishlist) {
                    document.querySelector('.cart-wishlist-title .nb-products').innerHTML = resp.result.wishlistLength;
                }
            }
        });
    });
});

/*
 * Remove product from rollover wishlist
 */
document.addEventListener("click", function(ev) {
    const target = ev.target;

    if (target.classList.contains("rollover-wishlist-remove-product")) {
        const id = target.getAttribute("data-id");
        const prodId = target.getAttribute("data-product-id");
        const colorId = target.getAttribute("data-color-id");
        const sizeId = target.getAttribute("data-size-id");
        const targetedProduct = target.closest('.rollover-basket-product');

        targetedProduct.setAttribute('is-processing', '');

        let datas = {
            id: id,
            remove: true
        };

        let productIdForRemove = id;

        if (prodId !== undefined && prodId !== null) {
            datas.product_id = prodId;
            productIdForRemove = prodId;
        }

        if (colorId !== undefined && colorId !== null) {
            datas.color_id = colorId;
        }

        if (sizeId !== undefined && sizeId !== null) {
            datas.size_id = sizeId;
        }

        (async () => {
            const response = await fetch(path_relative_root + create_link("ajax_remove_from_wishlist.php"), {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(datas).toString()
            });

            const ajaxUpdate = await fetch(path_relative_root + 'ajax_show_wishlist.php');
            const userWishlist = await ajaxUpdate.text();

            const wishlistTop = document.querySelector(".top-wishlist");
            if (wishlistTop) {
                wishlistTop.innerHTML = userWishlist;
            }
            changeBtnAddWishlist(false, prodId);
            checkWishProductStock();
        })();
    }
});

/*
 * Add all wishlist products from rollover wishlist to cart
 */
document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "add-all-products-to-wishlist") {
        e.preventDefault();
        e.target.setAttribute('is-processing', '');

        var selectedProducts = [];
        var selectedProductsAnonymous = [];
        var wishlistProductData = [];
        var isConnect = 0;

        document.querySelectorAll(".rollover-wishlist-move-product").forEach(function (el) {
            var id = el.getAttribute("data-id");
            wishlistProductData.push({
            productId: el.getAttribute("data-produit-id"),
            colorId: el.getAttribute("data-color-id"),
            sizeId: el.getAttribute("data-size-id"),
            });
            selectedProductsAnonymous = JSON.stringify(wishlistProductData);
            selectedProducts.push(id);
            isConnect = el.getAttribute("data-isconnect");
        });

        if (isConnect == 0) {
            allFromWishlistToCart(selectedProductsAnonymous, true);
        } else {
            allFromWishlistToCart(selectedProducts);
        }
    }
});

function displayWishlistTop() {
    const header = document.querySelector('header');
    const wishlistTop = document.querySelector('.top-wishlist');
    if (wishlistTop) {
        header.setAttribute('has-rollover', '');
        wishlistTop.setAttribute('is-displayed', '');
        toggleBackdrop(1);

        setTimeout(function () {
            header.removeAttribute('has-rollover');
            wishlistTop.removeAttribute('is-displayed');
            toggleBackdrop(0);
        }, 2000);
    }
}
